import Vue from 'vue';
import ElementUI from 'element-ui';
import '@/styles/theme/index.css';

Vue.use(ElementUI);